import React, { useState, useEffect } from 'react';
import '../css/hero.css';

export default function Hero() {
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndex(prevIndex => (prevIndex === 0 ? 1 : 0));
    }, 2000);

    return () => clearInterval(interval);
  }, []);
  return (
    <section>
      <div>
      {imageIndex === 0 ? (
        <img src='../../assets/hero/Hero.svg' className='hero' alt='Hero 1' />
      ) : (
        <img src='../../assets/hero/hero2.svg' className='hero' alt='Hero 2' />
      )}
    </div>
      
      <div className='bungkus-text'>
        {/* <div className='text'>Pendidikan Bermutu SMA Laboratorium UM Profesional</div> */}
        <div className='konten'>
          <div className='global'>
            <img src='../../assets/hero/wisuda.svg' className='wisuda'></img>
            <div className='w-kanan'>
              <p className='prestasi'>Prestasi</p>
              <h1 className='judul'>Global Learning Goes to Japang</h1>
              <button className='detail'>
                Lihat Detail
                <img src='../../assets/hero/arrow-right1.svg' className='right'></img>
              </button>
            </div>
          </div>
          <div className='angka-arrow'>
            <div className='arrow'>
              <img src='../../assets/hero/arrow-circle-left.svg' className='arrow-left'></img>
              <img src='../../assets/hero/arrow-circle-right.svg' className='arrow-right'></img>
            </div>
            <h1 className='angka'>
              01 <span>/ 03</span>
            </h1>
          </div>
        </div>
      </div>

    </section>
  )
}
